export const ChatType = {
  allchat: "allChat",
  mychat: "myChat",
};
